import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { preserveEleone } from "@/utils/preserveEleone";

/**
 * Breadcrumbs. Fil d'Ariane premium & discret.
 * Génère le rendu visuel + les métadonnées Schema.org BreadcrumbList (SEO).
 * Usage : <Breadcrumbs items={[{ label: "Marques", to: "/marques" }, { label: "NANDA SÁ" }]} />
 */
export default function Breadcrumbs({ items = [], className = "" }) {
  if (!items || items.length === 0) return null;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: "https://nanda-sa.com/" },
      ...items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 2,
        name: it.label,
        ...(it.to ? { item: `https://nanda-sa.com${it.to}` } : {}),
      })),
    ],
  };

  return (
    <nav
      aria-label="Breadcrumb"
      data-testid="breadcrumbs"
      className={`label-overline text-nanda-muted flex items-center gap-2 flex-wrap ${className}`}
    >
      <Link to="/" className="hover:text-nanda-ink transition-colors">Home</Link>
      {items.map((it, i) => (
        <React.Fragment key={i}>
          <ChevronRight size={12} strokeWidth={1.5} className="text-nanda-line" />
          {it.to && i < items.length - 1 ? (
            <Link to={it.to} className="hover:text-nanda-ink transition-colors">{preserveEleone(it.label)}</Link>
          ) : (
            <span className="text-nanda-ink">{preserveEleone(it.label)}</span>
          )}
        </React.Fragment>
      ))}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    </nav>
  );
}
